import { Box, Card, Stack, Typography, Button } from "@mui/material";

export default function PlayCreatorAd(props) {
  return (
    <Box sx={{ py: 6, px: 3, textAlign: "left" }}>
      <Stack direction="row" spacing={{ xs: 0, sm: 6 }}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box>
            <Card
              sx={(theme) => ({
                [theme.breakpoints.down("sm")]: {
                  display: "none",
                },
                boxShadow: 10,
                borderRadius: 1,
                margin: "auto",
              })}
            >
              <img
                width="300"
                src="https://app.thehoopsgeek.com/assets/illustrations/Hero4.png"
              />
            </Card>
          </Box>
        </Box>

        <Stack
          sx={(theme) => ({
            [theme.breakpoints.down("sm")]: {
              textAlign: "center",
            },
          })}
          spacing={{ xs: 3, md: 3 }}
          direction="column"
        >
          <Typography
            variant="h3"
            sx={{ fontWeight: 800, fontFamily: "Barlow,sans-serif" }}
          >
            Draw Your Own Plays. {"  "}
            <Box
              sx={{
                display: "inline",
                color: "primary.main",
                textDecoration: "underline",
              }}
            >
              It's easy!{" "}
            </Box>{" "}
          </Typography>
          <Box
            sx={(theme) => ({
              [theme.breakpoints.up("sm")]: {
                display: "none",
              },
              p: 2,
            })}
          >
            <Card sx={{ boxShadow: 10, borderRadius: 1 }}>
              <img src="https://app.thehoopsgeek.com/assets/illustrations/Hero4.png" />
            </Card>
          </Box>

          <Typography variant="body1" sx={{ fontFamily: "Poppins,sans-serif" }}>
            Create plays within seconds with an intuitive drag & drop interface.
            <br />
            Your plays will be animated automatically!
          </Typography>
          <Box>
            <Button
              href="https://app.thehoopsgeek.com/?utm_source=viewer_banner"
              sx={{
                "&:hover": { color: "#fff" },
                fontFamily: "Poppins,sans-serif",
                maxWidth: 200,
              }}
              to="/dashboard"
              size="large"
              variant="contained"
            >
              Try it now
            </Button>
          </Box>
        </Stack>
      </Stack>
    </Box>
  );
}
